export const POSTCODE_SEARCH_TERM_MIN_LENGTH = 5;
export const POSTCODE_SEARCH_TERM_REGEX = /^[\w\s]+$/;

export const POSTCODE_SEARCH_TERM_MESSAGES = {
  minLength: "Please enter a full postcode",
  regex: "Postcode can only contain letters, numbers and spaces",
} as const;

export const isValidPostcodeSearchTerm = (searchTerm: string): boolean => {
  if (!searchTerm) {
    return false;
  }

  return (
    searchTerm.length >= POSTCODE_SEARCH_TERM_MIN_LENGTH &&
    POSTCODE_SEARCH_TERM_REGEX.test(searchTerm)
  );
};

export const getPostcodeSearchTermError = (
  searchTerm: string,
): string | undefined => {
  if (!searchTerm) {
    return undefined;
  }

  if (searchTerm.length < POSTCODE_SEARCH_TERM_MIN_LENGTH) {
    return POSTCODE_SEARCH_TERM_MESSAGES.minLength;
  }

  if (!POSTCODE_SEARCH_TERM_REGEX.test(searchTerm)) {
    return POSTCODE_SEARCH_TERM_MESSAGES.regex;
  }

  return undefined;
};
